/** 2-letter GST state codes stored on vendors/customers (varchar(2)). */
export const GST_STATE_OPTIONS = [
  { value: "AN", label: "Andaman and Nicobar (AN)" },
  { value: "AP", label: "Andhra Pradesh (AP)" },
  { value: "AR", label: "Arunachal Pradesh (AR)" },
  { value: "AS", label: "Assam (AS)" },
  { value: "BR", label: "Bihar (BR)" },
  { value: "CH", label: "Chandigarh (CH)" },
  { value: "CG", label: "Chhattisgarh (CG)" },
  { value: "DN", label: "Dadra and Nagar Haveli and Daman and Diu (DN)" },
  { value: "DL", label: "Delhi (DL)" },
  { value: "GA", label: "Goa (GA)" },
  { value: "GJ", label: "Gujarat (GJ)" },
  { value: "HR", label: "Haryana (HR)" },
  { value: "HP", label: "Himachal Pradesh (HP)" },
  { value: "JK", label: "Jammu and Kashmir (JK)" },
  { value: "JH", label: "Jharkhand (JH)" },
  { value: "KA", label: "Karnataka (KA)" },
  { value: "KL", label: "Kerala (KL)" },
  { value: "LA", label: "Ladakh (LA)" },
  { value: "LD", label: "Lakshadweep (LD)" },
  { value: "MP", label: "Madhya Pradesh (MP)" },
  { value: "MH", label: "Maharashtra (MH)" },
  { value: "MN", label: "Manipur (MN)" },
  { value: "ML", label: "Meghalaya (ML)" },
  { value: "MZ", label: "Mizoram (MZ)" },
  { value: "NL", label: "Nagaland (NL)" },
  { value: "OD", label: "Odisha (OD)" },
  { value: "PY", label: "Puducherry (PY)" },
  { value: "PB", label: "Punjab (PB)" },
  { value: "RJ", label: "Rajasthan (RJ)" },
  { value: "SK", label: "Sikkim (SK)" },
  { value: "TN", label: "Tamil Nadu (TN)" },
  { value: "TS", label: "Telangana (TS)" },
  { value: "TR", label: "Tripura (TR)" },
  { value: "UP", label: "Uttar Pradesh (UP)" },
  { value: "UK", label: "Uttarakhand (UK)" },
  { value: "WB", label: "West Bengal (WB)" },
]
